/**
 * vue-moment
 *
 * Handy Moment.js filters for your Vue.js project.
 *
 * @see  https://www.npmjs.com/package/vue-moment
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

import Vue from 'vue'
Vue.use(require('vue-moment'));



// WEBPACK FOOTER //
// ./resources/js/services/vue-moment.js